import React, { useEffect, useState } from 'react';
import GroupIcon from '@material-ui/icons/Group';
import PersonIcon from '@material-ui/icons/Person';

const FormControlLabelLayout = ({ isGroup, item }) => {
  const [showUsers, setShowUsers] = useState([]);
  const [remainingUsers, setRemainingUsers] = useState(0);

  const setGroupUsersLayout = (groupUsers) => {
    if (groupUsers.length > 0 && groupUsers.length === 1) {
      setRemainingUsers(0);
      setShowUsers([groupUsers[0].name]);
    } else if (groupUsers.length > 0 && groupUsers.length > 1) {
      setShowUsers([groupUsers[0].name, groupUsers[1].name]);
      setRemainingUsers(groupUsers.length - 2);
    } else {
      setShowUsers([]);
      setRemainingUsers(0);
    }
  };

  useEffect(() => {
    if (isGroup) {
      setGroupUsersLayout(item);
    }
  }, []);

  return (
    <div className="label-container">
      <figure>
        {isGroup ? (
          <GroupIcon style={{ fontSize: 20 }} />
        ) : (
          <PersonIcon style={{ fontSize: 20 }} />
        )}
      </figure>
      <div>
        <span className="label-title">{item.name}</span>
        {showUsers.length === 0 && <></>}
        {showUsers.length > 0 && (
          <div className="label-details__users">
            <span>{showUsers.join(', ')}</span>
            {remainingUsers > 0 && (
              <span>{`, + ${remainingUsers} more...`}</span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default FormControlLabelLayout;
